import React, { useEffect, useState } from "react";
import {
  toDataSourceRequest,
  translateDataSourceResultGroups,
} from "@progress/kendo-data-query";
import axios from "axios"; // Ensure axios is imported if not already

/**
 * @type {import("@progress/kendo-data-query").DataResult}
 */
const initialData = { data: [], total: 0 };

/**
 *
 * @param {import("axios").AxiosInstance} axiosInstance
 * @param {import("@progress/kendo-data-query").DataSourceRequestState} dataState
 * @param {*} config
 * @returns
 */
export const useDataFilterApi = (axiosInstance, dataState, config = {}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [fetched, setIsFetched] = useState(false);
  const [data, setData] = useState(initialData);
  const [lastId, setLastId] = useState();
  const [cancelTokenSource, setCancelTokenSource] = useState(null);

  const fetchData = React.useCallback(() => {
    setIsLoading(true);
    if (cancelTokenSource) {
      cancelTokenSource.cancel("Operation canceled due to new request.");
    }

    const source = axios.CancelToken.source();
    setCancelTokenSource(source);
    const promise =
      config.method !== "post"
        ? axiosInstance.get(config.url || "", {
            params: {
              ...toDataSourceRequest(dataState),
              ...config.otherState,
            },
            cache: !!config.cache,
            cancelToken: source.token,
          })
        : axiosInstance.post(config.url || "", config.otherState || {}, {
            cache: !!config.cache,
            params: toDataSourceRequest(dataState),
            cancelToken: source.token,
          });
    return promise
      .then((response) => {
        const resultData = dataState.group?.length
          ? translateDataSourceResultGroups(response.data)
          : response.data;
        setData(resultData);
        setLastId(response.id);
        setIsFetched(true);
        return resultData;
      })
      .finally(() => {
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        if (axios.isCancel(error)) {
          console.log("Request canceled", error.message);
        } else {
          setIsError(true);
          console.log(error);
        }
      });

    // Cancel the previous request if it exists
  }, [config.cache, dataState, config.url, config.otherState]);

  useEffect(() => {
    if (!config.skip) {
      fetchData();
    }
  }, [config.skip, fetchData]);

  const reFetch = React.useCallback(() => {
    if (axiosInstance.storage) axiosInstance.storage.remove(lastId);
    return fetchData();
  }, [fetchData, lastId, axiosInstance.storage]);
  return { data, isLoading, isError, reFetch };
};

useDataFilterApi.defaultProps = {
  skip: false,
  cache: false,
  url: "",
};
